import React, { useContext, useState } from "react";
import ReactMapGl, { Marker } from "react-map-gl";
import { context } from "../../context/context";
import "mapbox-gl/dist/mapbox-gl.css";
import { PushpinFilled } from "@ant-design/icons";
const PlaceMap = () => {
    const mapboxToken =
        "pk.eyJ1IjoibWdoMzEyNyIsImEiOiJjbG1idzdyMnkwN3FjM2psa2gyZWZjaHh2In0.DmEE3by0gTbRGLupD6dTWA";
    const { setLatLng, latLng } = useContext(context);
    const [viewport, setViewport] = useState({
        latitude: 35.583313,
        longitude: 53.388842,
        zoom: 12,
    });

    return (
        <div style={{ width: "100%", height: "500px", overflow: "hidden" }}>
            <ReactMapGl
                width="100%"
                height="100%"
                {...viewport}
                doubleClickZoom={false}
                onClick={(e) => {
                    setLatLng([e.lngLat.lat, e.lngLat.lng]);
                }}
                onMouseOver={(viewport) => {
                    setViewport(viewport);
                }}
                mapStyle="mapbox://styles/mapbox/streets-v11"
                mapboxAccessToken={mapboxToken}
            >
                {latLng && (
                    <Marker latitude={latLng[0]} longitude={latLng[1]}>
                        <PushpinFilled
                            style={{ fontSize: "30px", color: "red" }}
                        />
                    </Marker>
                )}
            </ReactMapGl>
        </div>
    );
};

export default PlaceMap;
